import useCarouselLayout from "../../hooks/useCarouselLayout";
import React from "react";
import Slider from "react-slick";
import subtractImage from "../../Assets/likes.png";

import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar
} from "react-icons/fa";

import AOS from "aos";
import "aos/dist/aos.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


/* =========================================================
   ARROWS
========================================================= */

function NextArrow(props) {
  const { className, onClick } = props;

  return (
    <button type="button" aria-label="Next testimonial"
      className={`${className} arrow next`}
      onClick={onClick}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4 12H20M20 12L14 6M20 12L14 18"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}


function PrevArrow(props) {
  const { className, onClick } = props;

  return (
    <button type="button" aria-label="Previous testimonial"
      className={`${className} arrow prev`}
      onClick={onClick}
    >
      <svg
        width="50"
        height="50"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20 12H4M4 12L10 6M4 12L10 18"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}


export default function Section5() {
  const { containerRef, slidesToShow } = useCarouselLayout(3);

  /* =========================================================
     AOS
  ========================================================= */

  React.useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);


  /* =========================================================
     SLIDER SETTINGS
  ========================================================= */

const settings = {
  dots: false,
  infinite: true,

  speed: 600,

  slidesToShow,
  slidesToScroll: 1,

  // IMPORTANT: normal Slick structure
  centerMode: false,
  centerPadding: "0px",

  arrows: true,

  autoplay: true,
  autoplaySpeed: 3000,

  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,


};


  /* =========================================================
     TESTIMONIAL DATA
  ========================================================= */

  const testimonials = [
    {
      name: "Andrez Lopez",
      text:
        "Lorem ipsum dolor sit amet consectetur. Platea quis ultrices a interdum neque egestas.",
      rating: 4.5,
    },

    {
      name: "John Doe",
      text:
        "Lorem ipsum dolor sit amet consectetur. Platea quis ultrices a interdum neque egestas.",
      rating: 3,
    },

    {
      name: "Maria",
      text:
        "Lorem ipsum dolor sit amet consectetur. Platea quis ultrices a interdum neque egestas.",
      rating: 5,
    },

    {
      name: "Maria",
      text:
        "Lorem ipsum dolor sit amet consectetur. Platea quis ultrices a interdum neque egestas.",
      rating: 5,
    },

    {
      name: "Maria",
      text:
        "Lorem ipsum dolor sit amet consectetur. Platea quis ultrices a interdum neque egestas.",
      rating: 5,
    },
  ];


  return (
    <>
      <style>{`

        /* =====================================================
           MAIN SECTION
        ===================================================== */

        .testimonial-section {

          position: relative;

          width: 100%;

          padding: 80px 0;

          text-align: center;

          color: #ffffff;

          background-image:
            url(${subtractImage});

          background-size: cover;

          background-position: center;

          background-repeat: no-repeat;

          overflow: hidden;

          z-index: 2;
        }


        /* =====================================================
           BACKGROUND OVERLAY
        ===================================================== */

        .testimonial-section::before {

          content: "";

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              135deg,
              rgba(29, 78, 216, 0.82),
              rgba(16, 185, 129, 0.82)
            );

          z-index: 0;
        }


        /* subtle background glow */

        .testimonial-section::after {

          content: "";

          position: absolute;

          width: 500px;

          height: 500px;

          right: -200px;

          top: -250px;

          border-radius: 50%;

          background:
            rgba(255, 255, 255, 0.08);

          filter: blur(2px);

          pointer-events: none;

          z-index: 0;
        }


        /* =====================================================
           CONTENT
        ===================================================== */

        .sec5_title,
        .testimonial-section .slider-wrapper {

          position: relative;

          z-index: 1;
        }


        /* =====================================================
           TITLE
        ===================================================== */

        .sec5_title {

          font-size: 34px;

          font-weight: 700;

          line-height: 1.3;

          margin: 0 0 50px;

          padding-top: 30px;

          padding-bottom: 30px;

          letter-spacing: -0.4px;
        }


        /* =====================================================
           TITLE LINE
        ===================================================== */

        .sec5_title::after {

          content: "";

          display: block;

          width: 60px;

          height: 3px;

          margin: 14px auto 0;

          border-radius: 10px;

          background:
            linear-gradient(
              90deg,
              #ffffff,
              rgba(255,255,255,0.45)
            );
        }


        /* =====================================================
           SLIDER WRAPPER
        ===================================================== */

        .testimonial-section .slider-wrapper {

          width: 100%;

          max-width: 1100px;

          margin: 0 auto;

          position: relative;

          padding: 0 20px;

          box-sizing: border-box;
        }


        /* =====================================================
           TESTIMONIAL CARD
        ===================================================== */

        .testimonial-card {

          width: 315px;

          height: 350px;

          margin: 0 auto;

          padding: 25px 20px;

          box-sizing: border-box;

          position: relative;

          color: #ffffff;

          text-align: center;

          display: flex;

          flex-direction: column;

          justify-content: center;

          align-items: center;

          overflow: hidden;

          border-radius: 16px;

          background:
            linear-gradient(
              145deg,
              rgba(2, 74, 147, 0.68),
              rgba(4, 93, 135, 0.52)
            );

          backdrop-filter: blur(12px);

          -webkit-backdrop-filter: blur(12px);

          border:
            1px solid rgba(255,255,255,0.22);

          box-shadow:
            0 10px 25px rgba(0,0,0,0.22),
            0 3px 8px rgba(0,0,0,0.12),
            inset 0 1px 1px rgba(255,255,255,0.14);

          transition:
            transform 0.45s ease,
            box-shadow 0.45s ease,
            border-color 0.45s ease;
        }


        /* =====================================================
           CARD LIGHT EFFECT
        ===================================================== */

        .testimonial-card::before {

          content: "";

          position: absolute;

          inset: 0;

          border-radius: 16px;

          background:
            linear-gradient(
              120deg,
              transparent 20%,
              rgba(255,255,255,0.14),
              transparent 80%
            );

          transform:
            translateX(-120%);

          transition:
            transform 0.7s ease;

          pointer-events: none;
        }


        .testimonial-card:hover::before {

          transform:
            translateX(120%);
        }


        /* =====================================================
           CARD HOVER
        ===================================================== */

        .testimonial-card:hover {

          transform:
            translateY(-8px);

          border-color:
            rgba(255,255,255,0.38);

          box-shadow:
            0 22px 45px rgba(0,0,0,0.30),
            0 8px 18px rgba(0,0,0,0.18),
            inset 0 1px 2px rgba(255,255,255,0.20);
        }


        /* =====================================================
           CENTER CARD
        ===================================================== */

        .testimonial-section .slick-center .testimonial-card {

          transform:
            scale(1.05);

          box-shadow:
            0 18px 40px rgba(0,0,0,0.30),
            0 5px 15px rgba(0,0,0,0.15),
            inset 0 1px 2px rgba(255,255,255,0.18);
        }


        .testimonial-section .slick-center .testimonial-card:hover {

          transform:
            scale(1.07)
            translateY(-7px);
        }


        /* =====================================================
           NAME
        ===================================================== */

        .t-name {

          margin: 0 0 55px;

          font-family: "Space Grotesk", sans-serif;

          font-weight: 700;

          font-size: 20px;

          line-height: 1;

          letter-spacing: 0;
        }


        /* =====================================================
           QUOTE WRAPPER
        ===================================================== */

        .t-quote {

          position: relative;

          max-width: 220px;

          width: 100%;
        }


        /* =====================================================
           QUOTE ICON
        ===================================================== */

        .quote {

          position: absolute;

          top: -45px;

          left: -21px;

          font-size: 60px;

          line-height: 1;

          opacity: 0.28;

          font-family: Georgia, serif;

          pointer-events: none;
        }


        /* =====================================================
           TESTIMONIAL TEXT
        ===================================================== */

        .t-quote p {

          margin: 0 0 25px;

          font-family:
            "Space Grotesk",
            sans-serif;

          font-weight: 400;

          font-size: 16px;

          line-height: 1.8;

          letter-spacing: 0;

          text-align: center;

          color:
            rgba(255,255,255,0.90);
        }


        /* =====================================================
           STARS
        ===================================================== */

        .t-stars {

          display: flex;

          justify-content: center;

          align-items: center;

          gap: 5px;

          color: #ffffff;

          font-size: 18px;

          transition:
            transform 0.3s ease;
        }


        .testimonial-card:hover .t-stars {

          transform:
            translateY(-2px);
        }


        .t-stars svg {

          transition:
            transform 0.25s ease,
            filter 0.25s ease;
        }


        .t-stars svg:hover {

          transform:
            scale(1.18);
        }


        .t-stars svg:nth-child(-n+5) {

          filter:
            drop-shadow(
              0 2px 4px
              rgba(0,0,0,0.20)
            );
        }


        /* =====================================================
           ARROWS
        ===================================================== */

        .testimonial-section .arrow {

          position: absolute;

          top: 50%;

          transform:
            translateY(-50%);

          cursor: pointer;

          z-index: 30;

          width: 48px;

          height: 48px;

          display: flex;

          align-items: center;

          justify-content: center;

          border-radius: 50%;

          background:
            rgba(255,255,255,0.10);

          border:
            1px solid rgba(255,255,255,0.28);

          backdrop-filter:
            blur(8px);

          -webkit-backdrop-filter:
            blur(8px);

          transition:
            transform 0.35s ease,
            background 0.35s ease,
            box-shadow 0.35s ease;
        }


        .testimonial-section .arrow svg {

          transition:
            transform 0.35s ease;
        }


        .testimonial-section .arrow:hover {

          background:
            rgba(255,255,255,0.22);

          box-shadow:
            0 8px 20px
            rgba(0,0,0,0.20);

          transform:
            translateY(-50%)
            scale(1.08);
        }


        .testimonial-section .arrow:hover svg {

          transform:
            scale(1.12);
        }


        .testimonial-section .prev {

          left: -55px;
        }


        .testimonial-section .next {

          right: -55px;
        }


        /* =====================================================
           REMOVE DEFAULT SLICK ARROWS
        ===================================================== */

        .testimonial-section .slick-prev::before,
        .testimonial-section .slick-next::before {

          display: none !important;
        }


        /* =====================================================
           SLICK LIST
        ===================================================== */

      /* =====================================================
   SLICK STRUCTURE
===================================================== */

.testimonial-section .slider-wrapper .slick-slider {
  width: 100%;
  position: relative;
}

.testimonial-section .slider-wrapper .slick-list {
  overflow: hidden !important;
  padding: 30px 0 !important;
}

.testimonial-section .slider-wrapper .slick-track {
  display: flex;
  align-items: center;
}

.testimonial-section .slider-wrapper .slick-slide {
  box-sizing: border-box;
}

.testimonial-section .slider-wrapper .slick-slide > div {
  width: 100%;
}


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1024px) {

          .testimonial-section {

            padding:
              70px 0;
          }


          .testimonial-section .slider-wrapper {

            max-width:
              850px;

            padding:
              0 30px;
          }


          .testimonial-card {

            width:
              300px;
          }


          .testimonial-section .prev {

            left:
              -10px;
          }


          .testimonial-section .next {

            right:
              -10px;
          }


          .testimonial-section .slick-center .testimonial-card {

            transform:
              scale(1.02);
          }
        }


        /* =====================================================
           MOBILE TABLET
        ===================================================== */

        @media (max-width: 768px) {

          .testimonial-section {

            padding:
              55px 0;
          }


          .sec5_title {

            font-size:
              28px;

            margin-bottom:
              25px;

            padding:
              20px 20px;
          }


          .testimonial-section .slider-wrapper {

            padding:
              0 45px;
          }


          .testimonial-card {

            width:
              315px;

            max-width:
              100%;

            height:
              340px;
          }


          .testimonial-section .slick-center .testimonial-card {

            transform:
              scale(1);
          }


          .testimonial-section .slick-center .testimonial-card:hover {

            transform:
              translateY(-7px);
          }


          .testimonial-section .arrow {

            width:
              42px;

            height:
              42px;
          }


          .testimonial-section .prev {

            left:
              -5px;
          }


          .testimonial-section .next {

            right:
              -5px;
          }


          .testimonial-section .slick-list {

            padding:
              45px 0 !important;
          }
        }


        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 480px) {

          .testimonial-section {

            padding:
              45px 0;
          }


          .sec5_title {

            font-size:
              24px;

            line-height:
              1.4;

            margin-bottom:
              15px;
          }


          .testimonial-section .slider-wrapper {

            padding:
              0 38px;
          }


          .testimonial-card {

            height:
              330px;

            padding:
              25px 18px;
          }


          .t-name {

            font-size:
              19px;

            margin-bottom:
              50px;
          }


          .t-quote p {

            font-size:
              15px;

            line-height:
              1.7;
          }


          .testimonial-section .arrow {

            width:
              38px;

            height:
              38px;
          }


          .testimonial-section .arrow svg {

            width:
              30px;

            height:
              30px;
          }


          .testimonial-section .prev {

            left:
              -2px;
          }


          .testimonial-section .next {

            right:
              -2px;
          }
        }
          @media (max-width: 1024px) {

          .testimonial-section {

            padding:
              70px 0;
          }


          .testimonial-section .slider-wrapper {

            max-width:
              850px;

            padding:
              0 30px;
          }


          .testimonial-card {

            width:
              300px;
          }


          .testimonial-section .prev {

            left:
              -10px;
          }


          .testimonial-section .next {

            right:
              -10px;
          }


          .testimonial-section .slick-center .testimonial-card {

            transform:
              scale(1.02);
          }
        }

@media (max-width: 768px) {

          .testimonial-section {

            padding:
              55px 0;
          }


          .sec5_title {

            font-size:
              28px;

            margin-bottom:
              25px;

            padding:
              20px 20px;
          }


          .testimonial-section .slider-wrapper {

            padding:
              0 45px;
          }


          .testimonial-card {

            width:
              315px;

            max-width:
              100%;

            height:
              340px;
          }


          .testimonial-section .slick-center .testimonial-card {

            transform:
              scale(1);
          }


          .testimonial-section .slick-center .testimonial-card:hover {

            transform:
              translateY(-7px);
          }


          .testimonial-section .arrow {

            width:
              42px;

            height:
              42px;
          }


          .testimonial-section .prev {

            left:
              -5px;
          }


          .testimonial-section .next {

            right:
              -5px;
          }


          .testimonial-section .slick-list {

            padding:
              45px 0 !important;
          }
        }


.testimonial-section .slider-wrapper { min-width: 0; }
.testimonial-section .testimonial-card { width: 100%; max-width: 100%; min-width: 0; }
.testimonial-section .slick-slide { padding-inline: 10px; }
@media (max-width: 640px) {
  .testimonial-section .slider-wrapper { padding-inline: 16px; }
  .testimonial-section .slick-list { padding: 12px 0 68px !important; }
  .testimonial-section .slick-slide { padding-inline: 4px; }
  .testimonial-section .testimonial-card {
    height: auto;
    min-height: 300px;
    padding: 24px 18px;
    overflow: visible;
  }
  .testimonial-section .t-name { margin-bottom: 24px; }
  .testimonial-section .t-quote p { font-size: 15px; line-height: 1.7; overflow-wrap: break-word; }
  .testimonial-section .arrow {
    top: auto;
    bottom: 0;
    transform: none;
    width: 44px;
    height: 44px;
  }
  .testimonial-section .prev { left: calc(50% - 52px); }
  .testimonial-section .next { right: calc(50% - 52px); }
  .testimonial-section .arrow:hover { transform: none; }
}
`}</style>


      <section
        className="testimonial-section"
        data-aos="fade-up"
        data-aos-duration="700"
      >

        <h2
          className="sec5_title"
          data-aos="fade-down"
          data-aos-duration="650"
          data-aos-delay="100"
        >
          What Customer says about us
        </h2>


        <div
          className="slider-wrapper"
          ref={containerRef}
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="180"
        >

          <Slider {...settings}>

            {testimonials.map((item, i) => (

              <div key={i}>

                <div className="testimonial-card">

                  <h3 className="t-name">
                    {item.name}
                  </h3>


                  <div className="t-quote">

                    <span className="quote">
                      “
                    </span>

                    <p>
                      {item.text}
                    </p>

                  </div>


                  <div className="t-stars">

                    {[...Array(5)].map((_, starIndex) => {

                      const starValue =
                        starIndex + 1;

                      if (
                        item.rating >=
                        starValue
                      ) {

                        return (
                          <FaStar
                            key={starIndex}
                            className="star filled"
                          />
                        );

                      } else if (
                        item.rating >=
                        starValue - 0.5
                      ) {

                        return (
                          <FaStarHalfAlt
                            key={starIndex}
                            className="star filled"
                          />
                        );

                      } else {

                        return (
                          <FaRegStar
                            key={starIndex}
                            className="star empty"
                          />
                        );

                      }

                    })}

                  </div>

                </div>

              </div>

            ))}

          </Slider>

        </div>

      </section>
    </>
  );
}
